module.exports = __webpack_public_path__ + "static/img/number_06@2x.026c1d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productServices/brandOperation/serviceContent/number_06@2x.png
// module id = pf+z
// module chunks = 0